<template>
    <v-col cols="12" class="Payment2 mt-0 pt-0">
        <v-row
                align="stretch"
                justify="space-around"
                class="pa-4 pt-0"
                style="height: 100%"
        >
            <v-col cols="12" >
                <v-card
                        class="pa-4 elevation-0"
                        tile
                        height="100%"
                >
                 <v-row >
                        <v-col>
                            <h2 class="font-weight-medium text-center title-reports my-6">Pago de Servicios Neocity</h2>
                        </v-col>
                        <v-btn
                                    
                                    dark
                                    fab
                                    x-small
                                    class="mx-2"
                                    color="#7F03BB"
                                    to="/system/reports/payment"
                            >
                                <v-icon>mdi-cart</v-icon>
                        </v-btn>  
                        <v-btn
                                    
                                    dark
                                    fab
                                    x-small
                                    class="mx-2"
                                    color="#FFB12A"
                                    @click="dialog.video = true"
                            >
                                <v-icon>mdi-play</v-icon>
                        </v-btn>  
                        <v-btn
                                    
                                    dark
                                    fab
                                    x-small
                                    class="mx-2"
                                    color="#0172C0"
                            >
                                <v-icon>mdi-flash</v-icon>
                        </v-btn>  
                    </v-row>
                        <v-row>
                            <v-col cols="12" class="d-none d-md-block">
                                <v-stepper alt-labels>
                                    <v-stepper-header class="text-center elevation-0">
                                        <v-stepper-step step="1" complete>Selecciona tus productos</v-stepper-step>

                                        <v-divider class="complete"></v-divider>

                                        <v-stepper-step step="2" complete>Selecciona tu medio de pago</v-stepper-step>

                                        <v-divider class="complete"></v-divider>

                                        <v-stepper-step step="3" complete>Datos de facturación</v-stepper-step>

                                        <v-divider></v-divider>

                                        <v-stepper-step step="4">Términos y condiciones</v-stepper-step>

                                        <v-divider></v-divider>

                                        <v-stepper-step step="5">Realiza tu pago</v-stepper-step>
                                        <v-divider></v-divider>

                                        <v-stepper-step step="6">Comprobante de compra</v-stepper-step>
                                    </v-stepper-header>
                                </v-stepper>
                            </v-col>
                            <v-col cols="12" v-if="errorPayment">
                                <v-row class="align-center" >
                                    <v-col cols="12" lg="2">
                                        <v-icon size="200" color="red">mdi-close-circle-outline</v-icon>
                                    </v-col>
                                    <v-col cols="12" lg="6">
                                        <h2 class="font-weight-medium">oh! Algo salió mal </h2>
                                        <p>Hola <b>Usuario!</b> Algo salió mal en el proceso de pago. Inténtalo nuevamente mas tarde. Si vuelves a tener problemas, no dudes en contactarnos para poder ayudarte.</p>
                                    </v-col>
                                </v-row>
                            </v-col>
                           <v-col cols="12" lg="8">
                            <h4 class="my-4 mt-8">Datos de facturacion</h4>
                                <v-row class="datos-facturacion">
                                    <v-col>
                                        <v-text-field
                                                placeholder="Razon social"
                                                dense
                                        ></v-text-field>
                                        <v-text-field
                                                placeholder="Nombres"
                                                dense
                                        ></v-text-field>
                                        <v-text-field
                                                placeholder="Dirección"
                                                dense
                                        ></v-text-field>
                                        <v-text-field
                                                placeholder="Telefono"
                                                dense
                                        ></v-text-field>
                                    </v-col>
                                    <v-col>
                                        <v-text-field
                                                placeholder="Rut de la Empresa"
                                                dense
                                        ></v-text-field>
                                        <v-text-field
                                                placeholder="Apellidos"
                                                dense
                                        ></v-text-field>
                                        <v-text-field
                                                placeholder="Ciudad"
                                                dense
                                        ></v-text-field>
                                        <v-text-field
                                                placeholder="Email"
                                                dense
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                           </v-col>
                            <v-col cols="12" lg="4">
                                <h4 class="mb-4">Detalles de la compra</h4>

                                <v-card style="border: 3px solid #2196F3" class="rounded-lg detalleCompra">
                                    <v-card-title>
                                        <v-row class="px-2">
                                            <v-col cols="9">
                                                <h3>
                                                    Análisis de desempeño
                                                </h3>
                                                <p>Suscripción única</p>
                                            </v-col>
                                            <v-col cols="3">
                                                <h2 class="blue--text text-right">
                                                    5UF
                                                </h2>
                                            </v-col>
                                        </v-row>
                                        <v-col cols="12">
                                                <v-divider></v-divider>
                                        </v-col>
                                        <v-row class="px-2">
                                            <v-col cols="9">
                                                <h3>
                                                    Consumo  Anual Energía
                                                </h3>
                                                <p>Suscripción única</p>
                                            </v-col>
                                            <v-col cols="3">
                                                <h2 class="blue--text text-right">
                                                    5UF
                                                </h2>
                                            </v-col>
                                        </v-row>
                                    </v-card-title>
                                    <v-divider class="py-10"></v-divider>
                                    <v-card-text>
                                        <br>
                                    </v-card-text>
                                    <v-divider></v-divider>
                                    <v-card-actions>
                                        <v-row class="px-2">
                                            <v-col cols="9">
                                                <h3>
                                                    Total a pagar
                                                </h3>
                                            </v-col>
                                            <v-col cols="3">
                                                <h2 class="blue--text text-right">
                                                    10UF
                                                </h2>
                                                <p  class="blue--text text-right" >49.880 CLP</p>

                                            </v-col>
                                        </v-row>

                                    </v-card-actions>
                                </v-card>
                                <div class="d-flex">
                                    <v-checkbox >
                                </v-checkbox>
                                        <a class="font-size-13 mt-6" href="/system/reports/terms" target="_blank"  >He leido y acepto los terminos y condiciones</a>
                                </div>
                                
                                <v-btn color="green"
                                        raised
                                        dark
                                        to="/system/reports/payment-success"
                                        class="pa-6 px-12" style="width:100%">Pagar</v-btn>

                                <a href="#" @click="errorPayment = true" >cancelar</a>
                            </v-col>
                        </v-row>
                    
                </v-card>
            </v-col>
        </v-row>
    </v-col>
</template>
<style lang="scss">
    .datos-facturacion{
         .v-input{
            .v-input__control{
                font-size: 18px !important;
                .v-text-field__slot{
                     font-size: 18px !important;
                    padding-bottom:6px !important;
                }
        }
     }   
    }
</style>
<script>
    export default {
        name: 'Payment2',
        data() {
            return {
                errorPayment:false
            }
        },
        created: function () {
            this.$emit('SetcolorMenu', '#7F03BB');
        }
    }
</script>